module.exports = __webpack_public_path__ + "media/images/car-47322391fb94ce107ff047d8526bc04e.svg";